// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".isDisabled[data-v-2dffe1e5] {\n  opacity: 0.3;\n  pointer-events: none;\n}\n.p-userauthentication__line-link[data-v-2dffe1e5] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
